import { createFileRoute, redirect } from '@tanstack/react-router'
import { MinimalAuthLayout } from '@/components/layout/minimal-auth-layout'
import { CreateOrganizationPage } from '@/features/create-organization'

export const Route = createFileRoute('/_authenticated/create-organization/')({
  beforeLoad: () => {
    // TEMPORARY: Organization self-creation is blocked while admin flow is rolled out.
    throw redirect({ to: '/', replace: true })
  },
  component: () => (
    <MinimalAuthLayout>
      <CreateOrganizationPage />
    </MinimalAuthLayout>
  ),
})
